import { render } from "./TextMedia.vue?vue&type=template&id=ff19e8f6&scoped=true"
import script from "./TextMedia.vue?vue&type=script&lang=js"
export * from "./TextMedia.vue?vue&type=script&lang=js"

import "./TextMedia.vue?vue&type=style&index=0&id=ff19e8f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff19e8f6"]])

export default __exports__